/**
 * Created by hp on 2017/7/31.
 */
const defaults = {
    showImgDialog: false,
    img: '',
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'ACTIVITY_SHOW_IMG_DIALOG':
            return {...state, showImgDialog: true, img: action.payload};
        case 'ACTIVITY_HIDE_IMG_DIALOG':
            return {...state, showImgDialog: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/activity.js